import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { AuthService } from 'src/app/_provider/auth.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { HttpService } from 'src/app/_provider/http.service';
import { TaskTemplateEditPage } from '../task-template-edit/task-template-edit.page';

export interface TaskTemplateBase{
  id?: number,
  description: string
}

export interface TaskTemplateItem extends TaskTemplateBase{
  templateId: number
  sort: number
}

@Component({
  selector: 'app-task-template-overview',
  templateUrl: './task-template-overview.page.html',
  styleUrls: ['./task-template-overview.page.scss', "../../setting-main.scss"],
})
export class TaskTemplateOverviewPage implements OnInit {

  public searchText: string = ""

  public templatesFilter: TaskTemplateBase[] = []
  public templates: TaskTemplateBase[] = []

  public toSelect: boolean = false

  constructor(
    private modalCtrl: ModalController,
    private http: HttpService,
    public authSrv: AuthService,
    private feedback: FeedbackService
  ) { }

  async ngOnInit() {
    const response: HttpFunctionResult<TaskTemplateBase[]> = await this.http.GET({path: "ticket/editinfo/tasktemplates"})
    if(!response.success) return await this.back()

    this.templates = response.data
    this.searchTemplates()
  }

  public async createTemplate(){
    await this.feedback.openModal(TaskTemplateEditPage, {template: {description: ""}, isNew: true, templates: this.templates}, (result: HttpFunctionResult<any>)=>{
      this.searchTemplates()
    })
  }

  public async templatePressed(template: TaskTemplateBase){
    if(this.toSelect) await this.modalCtrl.dismiss(template)
    else await this.showTemplate(template)
  }

  public async showTemplate(template: TaskTemplateBase, event?: MouseEvent){
    if(event) event.stopPropagation()
    await this.feedback.showModal({
      component: TaskTemplateEditPage,
      componentProps: {template: template, templates: this.templates}
    }) 
  }

  public async back(){
    await this.modalCtrl.dismiss()
  }

  public searchTemplates(){
    this.templatesFilter = this.templates.filter(t => t.description.toLowerCase().includes(this.searchText.toLowerCase()))
  }

  public searchEnter(){
    if(this.templatesFilter.length == 1) this.templatePressed(this.templatesFilter[0])
  }

}